import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { PromocionesService } from '../../services/promociones.service';
import { Material } from '../../../portfolio/interfaces/material.interface';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { ApiResponse } from 'src/app/model/interfaces/response';

@Component({
  selector: 'app-promo-bono-form',
  templateUrl: './promo-bono-form.component.html',
  styleUrls: ['./promo-bono-form.component.css']
})
export class PromoBonoFormComponent implements OnInit {

  agregarFormBonificador!: FormGroup;
  comboGrupos = [];
  materialTitle: string = '';
  _bonificador?: any;
  _tipoPromo = '';

  @Input()
  set bonificador(data: any | undefined) {
    if (data) {
      this.agregarFormBonificador.patchValue(data);
      this.agregarFormBonificador.get("id_promo_ant").setValue(data.id_promo);
      this.agregarFormBonificador.get("id_material_ant").setValue(data.id_material);
      this.agregarFormBonificador.get("id_grupo_ant").setValue(data.id_grupo);
      this.agregarFormBonificador.get("id_unidad_ant").setValue(data.id_unidad);
      this.materialTitle = `${data.id_material}-${data.name_material}`;
      this._bonificador = data;
    }
  }

  @Input()
  set idPromo(id: string) {
    this.agregarFormBonificador.get('id_promo').setValue(id);
  }

  @Input()
  set tipoPromo(tipo: string) {
    this.onChangeTipo(tipo);
    this._tipoPromo = tipo;
  }

  @Input()
  set material(material: Material | undefined) {
    if (material) {
      this.agregarFormBonificador.get('id_material').setValue(material.idMaterial);
      this.materialTitle = `${material.idMaterial}-${material.dscaMaterial}`;
    }
  }

  @Input()
  grupos: boolean;

  @Output()
  back = new EventEmitter<void>();

  @Output()
  create = new EventEmitter<any>();

  @ViewChild('fileInput')
  fileInput: ElementRef;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly toastrService: ToastrService,
    private readonly promocionesService: PromocionesService,
    private readonly _util: UtilsService,
  ) {
    this.buildForm();
  }
  ngOnInit(): void {
    if (this._tipoPromo === '1' || this._tipoPromo === '2' || this._tipoPromo === '7') {
      this.cargarGrupo(this.agregarFormBonificador.get('id_promo').value);
    }
    if (!this.grupos) {
      this.setKeyEmptyDisabled('id_grupo');
    } else {
      this.setKeyEmptyDisabled('cantidad1');
    }
  }

  private buildForm() {
    this.agregarFormBonificador = this.formBuilder.group({
      id_promo: ['', []],
      id_promo_ant: ['', []],
      id_material: ['', [Validators.required]],
      id_material_ant: ['', []],
      id_grupo: ['', []],
      id_grupo_ant: ['', []],
      id_unidad: ['UN', []],
      id_unidad_ant: ['', []],
      cantidad1: [null, [Validators.min(1), Validators.max(99999)]],
      cantidad2: [null, [Validators.min(1), Validators.max(99999)]],
      cantidad3: [null, [Validators.min(1), Validators.max(99999)]],
      relacion21: [null, [Validators.min(1)]],
      descuento: [null, [Validators.min(1), Validators.max(99)]],
    })
  }

  accionesBonificadores(event: string) {
    if (event === 'guardar') {
      this.create.emit(this.agregarFormBonificador.getRawValue());
    } else {
      this.back.emit();
    }
  }

  setALLNoRequiredAndEnable() {
    Object.keys(this.agregarFormBonificador.controls).forEach(key => {
      this.agregarFormBonificador.get(key).setValidators([]);
      this.agregarFormBonificador.get(key).updateValueAndValidity();
      this.agregarFormBonificador.get(key).enable();
    });

    this.agregarFormBonificador.get('cantidad1').setValidators([Validators.min(1), Validators.max(99999)]);
    this.agregarFormBonificador.get('cantidad2').setValidators([Validators.min(1), Validators.max(99999)]);
    this.agregarFormBonificador.get('cantidad3').setValidators([Validators.min(1), Validators.max(99999)]);
    this.agregarFormBonificador.get('relacion21').setValidators([Validators.min(1)]);
    this.agregarFormBonificador.get('descuento').setValidators([Validators.min(1), Validators.max(99)]);
    this.agregarFormBonificador.get('id_material').setValidators([Validators.required]);
    if (!this._bonificador) {
      this.agregarFormBonificador.get('cantidad1').setValue(0);
      this.agregarFormBonificador.get('cantidad2').setValue(0);
      this.agregarFormBonificador.get('cantidad3').setValue(0);
      this.agregarFormBonificador.get('relacion21').setValue(0);
      this.agregarFormBonificador.get('descuento').setValue(0);
    }
  }

  setKeyEmptyDisabled(key, value = null) {
    // console.log("form, key", form, key)
    this.agregarFormBonificador.get(key).setValue(value);
    this.agregarFormBonificador.get(key).setValidators([]);
    this.agregarFormBonificador.get(key).updateValueAndValidity();
    this.agregarFormBonificador.get(key).disable();
  }

  onChangeTipo(tipo: string) {
    this.setALLNoRequiredAndEnable();
    switch (tipo.toString()) {
      case '1':
        this.setKeyEmptyDisabled('cantidad2');
        this.setKeyEmptyDisabled('cantidad3');
        this.setKeyEmptyDisabled('relacion21');
        this.setKeyEmptyDisabled('descuento');
        break;
      case '2':
        this.setKeyEmptyDisabled('cantidad2');
        this.setKeyEmptyDisabled('cantidad3');
        this.setKeyEmptyDisabled('relacion21');
        this.setKeyEmptyDisabled('descuento');
        break;
      case '3':
        this.setKeyEmptyDisabled('cantidad2');
        this.setKeyEmptyDisabled('cantidad3');
        this.setKeyEmptyDisabled('id_grupo');
        this.setKeyEmptyDisabled('descuento');
        break;
      case '4':
        this.setKeyEmptyDisabled('id_grupo');
        this.setKeyEmptyDisabled('relacion21');
        this.setKeyEmptyDisabled('descuento');
        break;
      case '5':
        this.setKeyEmptyDisabled('id_material');
        this.setKeyEmptyDisabled('id_unidad');
        this.setKeyEmptyDisabled('cantidad1');
        this.setKeyEmptyDisabled('cantidad2');
        this.setKeyEmptyDisabled('cantidad3');
        this.setKeyEmptyDisabled('id_grupo');
        this.setKeyEmptyDisabled('relacion21');
        this.setKeyEmptyDisabled('descuento');
        break;
      case '6':
        this.setKeyEmptyDisabled('cantidad1');
        this.setKeyEmptyDisabled('cantidad2');
        this.setKeyEmptyDisabled('cantidad3');
        this.setKeyEmptyDisabled('id_grupo');
        this.setKeyEmptyDisabled('relacion21');
        this.setKeyEmptyDisabled('descuento');
        break;
      case '7':
        this.setKeyEmptyDisabled('cantidad1');
        this.setKeyEmptyDisabled('cantidad2');
        this.setKeyEmptyDisabled('cantidad3');
        this.setKeyEmptyDisabled('relacion21');
        this.setKeyEmptyDisabled('descuento');
        break;
      case '8':
        this.setKeyEmptyDisabled('cantidad1');
        this.setKeyEmptyDisabled('cantidad2');
        this.setKeyEmptyDisabled('cantidad3');
        this.setKeyEmptyDisabled('id_grupo');
        this.setKeyEmptyDisabled('relacion21');
        this.setKeyEmptyDisabled('descuento');
        break;
      case '9':
        this.setKeyEmptyDisabled('cantidad2');
        this.setKeyEmptyDisabled('cantidad3');
        this.setKeyEmptyDisabled('id_grupo');
        this.setKeyEmptyDisabled('relacion21');
        break;
      // case 'COMBO_VIRTUAL' T.25842.sn
      case '10':
        this.setKeyEmptyDisabled('cantidad2');
        this.setKeyEmptyDisabled('cantidad3');
        this.setKeyEmptyDisabled('id_grupo');
        this.setKeyEmptyDisabled('relacion21');
        this.setKeyEmptyDisabled('descuento');
        break; 
      //T.25842.en    
    }
  }

  cargarGrupo(idPromo: string) {
    this.promocionesService.cargarGrupo(idPromo.trim()).subscribe(
      (resp) => {
        if (resp) {
          this.comboGrupos = resp;
        }
      }
    );
  }

  onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.toastrService.error('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV"');
        this.fileInput.nativeElement.value = '';
      } else {
        this.uploadCsv(file);
      }
    }
  }

  private uploadCsv(file) {
    const formData = new FormData();
    formData.append('file', new Blob([file], { type: 'text/csv' }), 'file');
    this._util
      .confirmarSincronoPromesa({
        title: '¿Esta seguro de enviar el siguiente archivo?',
        text: '',
        action: 'Enviar',
        funcion: this.promocionesService.bonificadorCsv(this.agregarFormBonificador.get('id_promo').value, formData)
      })
        .then((res: ApiResponse<string>) => {
          this.toastrService.success(res.mensaje, `${res.key}`);
        })
        .finally(() => this.fileInput.nativeElement.value = '');
  }
}
